// extracted by mini-css-extract-plugin
export default {"main_menu":"Home_main_menu__j1CA6","home_icon":"Home_home_icon__S9PVd","home_text":"Home_home_text__FuVou"};